import { render, staticRenderFns } from "./GroupBuyDetail.vue?vue&type=template&id=8f3e3b5e&scoped=true&"
import script from "./GroupBuyDetail.vue?vue&type=script&lang=js&"
export * from "./GroupBuyDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupBuyDetail.vue?vue&type=style&index=0&id=8f3e3b5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3e3b5e",
  null
  
)

export default component.exports